// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oZ8e","top":"styles_top__HffWe"};